import { create } from "zustand";

interface WelcomeInfo {
  ordersCountData: number | null;
  setOrdersCountData: (ordersCount: number | null) => void;
  ordersCountLoading: boolean;
  setOrdersCountLoading: (ordersCountLoading: boolean) => void;
  awardedBonus: string | null;
  setAwardedBonus: (bonusesData: string | null) => void;
  promoGiftDays: number | null;
  setPromoGiftDays: (days: number | null) => void;
  wasSubscribePayed: boolean | null;
  setWasSubscribePayed: (wasSubscribePayed: boolean | null) => void;
}

export const useWelcomeInfo = create<WelcomeInfo>()((set) => ({
  ordersCountData: null,
  setOrdersCountData: (ordersCountData) => set({ ordersCountData }),
  ordersCountLoading: true,
  setOrdersCountLoading: (ordersCountLoading) => set({ ordersCountLoading }),
  awardedBonus: null,
  setAwardedBonus: (awardedBonus) => set({ awardedBonus }),
  promoGiftDays: null,
  setPromoGiftDays: (promoGiftDays) => set({ promoGiftDays }),
  wasSubscribePayed: null,
  setWasSubscribePayed: (wasSubscribePayed) => set({ wasSubscribePayed }),
}));
